import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import * as PropTypes from 'prop-types';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';

// import Button from '$landing-page-raika/components/button';
// import StoreButton from '$landing-page-raika/components/store-button';
import BigHeaderLayout from '$landing-page-raika/layouts/big-header-layout';

import useStyles from './styles';

const query = graphql`
    query productIndexPage {
        site {
            siteMetadata {
                getStartedLink
                productRaikaHealth {
                    appStoreLink
                    googlePlayLink
                }
            }
        }
        pattern: file(relativePath: { eq: "page-product-pattern.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, width: 1920, quality: 100, placeholder: NONE)
            }
        }
        illustration: file(relativePath: { eq: "page-product-illustration.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, width: 533, quality: 100, placeholder: NONE)
            }
        }
        stepDesignImage: file(relativePath: { eq: "page-product-step-design-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        stepActivitiesImage: file(relativePath: { eq: "page-product-step-activities-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        stepSensorsImage: file(relativePath: { eq: "page-product-step-sensors-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        stepEnrollImage: file(relativePath: { eq: "page-product-step-enroll-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        stepTrackImage: file(relativePath: { eq: "page-product-step-track-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        stepAdjustImage: file(relativePath: { eq: "page-product-step-adjust-image.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 320, quality: 100, placeholder: NONE)
            }
        }
        arrowStepOneImage: file(relativePath: { eq: "page-product-arrow-step-one.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 240, quality: 100, placeholder: NONE)
            }
        }
        arrowStepTwoImage: file(relativePath: { eq: "page-product-arrow-step-two.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 210, quality: 100, placeholder: NONE)
            }
        }
        arrowStepThreeImage: file(relativePath: { eq: "page-product-arrow-step-three.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 240, quality: 100, placeholder: NONE)
            }
        }
        arrowStepFourImage: file(relativePath: { eq: "page-product-arrow-step-four.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 230, quality: 100, placeholder: NONE)
            }
        }
        arrowStepFiveImage: file(relativePath: { eq: "page-product-arrow-step-five.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 200, quality: 100, placeholder: NONE)
            }
        }
        arrowSmImage: file(relativePath: { eq: "page-product-arrow-sm.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 56, quality: 100, placeholder: NONE)
            }
        }
    }
`;

const ProductIndexPage = (props) => {
    const { location } = props;
    const classes = useStyles();
    const theme = useTheme();
    const isScreenSizeMd = useMediaQuery(theme.breakpoints.up('md'));
    const queryData = useStaticQuery(query);
    const title = `محصول`;
    const description = `با هر کاربر Android و iPhone به عنوان یک شرکت کننده بالقوه ، مطالعه خود را با سرعت و مقیاسی مانند قبل انجام دهید.`;
    return (
        <BigHeaderLayout
            pathname={location.pathname}
            title={title}
            description={description}
            // secondDescription={
            //     <Grid container className={classes.storeButtonsWrapper} alignItems="flex-start">
            //         <Grid item xs={12} md="auto">
            //             <a
            //                 href={queryData.site.siteMetadata.productRaikaHealth.appStoreLink}
            //                 target="_blank"
            //                 rel="noopener noreferrer"
            //                 className={classes.storeButton}
            //             >
            //                 <StoreButton type="image" variant="custom" store="apple" />
            //             </a>
            //         </Grid>
            //         <Grid item xs={12} md="auto">
            //             <a
            //                 href={queryData.site.siteMetadata.productRaikaHealth.googlePlayLink}
            //                 target="_blank"
            //                 rel="noopener noreferrer"
            //                 className={classes.storeButton}
            //             >
            //                 <StoreButton type="image" variant="custom" store="google-play" />
            //             </a>
            //         </Grid>
            //     </Grid>
            // }
            backgroundImage={queryData.pattern}
            illustrationImage={queryData.illustration}
        >
            <Typography variant="h4" color="textSecondary">
                چگونه کار می کند؟
            </Typography>
            <Grid container className={classes.stepsWrapper}>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid container wrap={isScreenSizeMd ? 'nowrap' : 'wrap'} alignItems="center" spacing={2}>
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepDesignImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>1.</span>
                                {` مطالعه را طراحی کنید`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                مطالعه خود را تنها در چند مرحله ساده طراحی کنید. تعریف تیم های تحقیقاتی ، کنترل دسترسی ، دوره
                                مشارکت ، مطالب فرم رضایت نامه و سایر پارامترها.
                            </Typography>
                        </Grid>
                    </Grid>
                    {isScreenSizeMd && (
                        <Box className={classes.arrowStepOneWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowStepOneImage)} alt="" />
                        </Box>
                    )}
                    {!isScreenSizeMd && (
                        <Box className={classes.arrowSmallWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowSmImage)} alt="" />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid
                        container
                        wrap={isScreenSizeMd ? 'nowrap' : 'wrap'}
                        alignItems="center"
                        className={classes.stepActivitiesWrapper}
                        spacing={2}
                    >
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepActivitiesImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>2.</span>
                                {` فعالیت ها را اضافه کنید`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                فعالیتهایی مانند نظرسنجی برای غربالگری شایستگی ، سوالات جمعیت شناختی ، EMA ، وظایف شناختی و سایر
                                عناصر مطالعه را به مطالعات خود اضافه کنید.
                            </Typography>
                        </Grid>
                    </Grid>
                    {isScreenSizeMd && (
                        <Box className={classes.arrowStepTwoWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowStepTwoImage)} alt="" />
                        </Box>
                    )}
                    {!isScreenSizeMd && (
                        <Box className={classes.arrowSmallWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowSmImage)} alt="" />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid
                        container
                        wrap={isScreenSizeMd ? 'nowrap' : 'wrap'}
                        alignItems="center"
                        spacing={2}
                        className={classes.stepSensorsWrapper}
                    >
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepSensorsImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>3.</span>
                                {` اضافه کردن داده های مبتنی بر حسگر`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                داده های حسگر را برای اندازه گیری عینی رفتارهای مهم در تحقیقات خود مانند GPS برای تحرک ، سنسورهای
                                حرکت برای فعالیت بدنی یا بلوتوث برای تعاملات اجتماعی انتخاب کنید.
                            </Typography>
                        </Grid>
                    </Grid>
                    {isScreenSizeMd && (
                        <Box className={classes.arrowStepThreeWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowStepThreeImage)} alt="" />
                        </Box>
                    )}
                    {!isScreenSizeMd && (
                        <Box className={classes.arrowSmallWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowSmImage)} alt="" />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid
                        container
                        wrap={isScreenSizeMd ? 'nowrap' : 'wrap'}
                        alignItems="center"
                        spacing={2}
                        className={classes.stepEnrollWrapper}
                    >
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepEnrollImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>4.</span>
                                {` شرکت کنندگان را ثبت نام کنید`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                شرکت کنندگان را به سادگی با ارائه کد مطالعه یا پیوند ثبت نام ، ثبت نام کنید. بازدید از نشانی
                                اینترنتی ثبت نام در تلفن هوشمند آنها شرکت کنندگان را از طریق مراحل مطالعه ، از غربالگری صلاحیت و
                                رضایت آگاهانه تا جمع آوری داده ها و سایر فعالیت ها راهنمایی می کند.
                            </Typography>
                        </Grid>
                    </Grid>
                    {isScreenSizeMd && (
                        <Box className={classes.arrowStepFourWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowStepFourImage)} alt="" />
                        </Box>
                    )}
                    {!isScreenSizeMd && (
                        <Box className={classes.arrowSmallWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowSmImage)} alt="" />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid
                        container
                        wrap={isScreenSizeMd ? 'nowrap' : 'wrap'}
                        spacing={2}
                        alignItems="center"
                        className={classes.stepTrackWrapper}
                    >
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepTrackImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>5.</span>
                                {` پیگیری بلادرنگ پیشرفت`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                داده های حسگر و پاسخ های فعالیت از طریق داشبورد ابن سینا چند دقیقه پس از جمع آوری در دسترس هستند ،
                                بنابراین می توانید پیشرفت مطالعه را در زمان واقعی ردیابی کرده و تجزیه و تحلیل داده ها را بلافاصله
                                شروع کنید.
                            </Typography>
                        </Grid>
                    </Grid>
                    {isScreenSizeMd && (
                        <Box className={classes.arrowStepFiveWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowStepFiveImage)} alt="" />
                        </Box>
                    )}
                    {!isScreenSizeMd && (
                        <Box className={classes.arrowSmallWrapper}>
                            <GatsbyImage image={getImage(queryData.arrowSmImage)} alt="" />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={10} className={classes.stepWrapper}>
                    <Grid
                        container
                        wrap={isScreenSizeMd ? 'nowrap' : 'wrap'}
                        spacing={2}
                        alignItems="center"
                        className={classes.stepAdjustWrapper}
                    >
                        <Grid item className={classes.stepImageWrapper}>
                            <GatsbyImage image={getImage(queryData.stepAdjustImage)} className={classes.stepImage} alt="" />
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="h4"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                <span className={classes.colorPurple}>6.</span>
                                {` در صورت نیاز تنظیم کنید`}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                align={isScreenSizeMd ? 'right' : 'center'}
                                display="block"
                            >
                                شما همیشه می توانید هر قسمتی از مطالعه را تنظیم و اصلاح کنید ، حتی در حالی که در حال انجام است ،
                                بنابراین مطالعه نیز می تواند با تکامل نیازها یا درک شما تکامل یابد. ابن سینا به طور خودکار دستگاه
                                های شرکت کنندگان را مطابق آن به روز می کند.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* <Grid container className={classes.bottomButtonsWrapper} justify="center">
                <Grid item xs={12} sm={10} md={7} lg={5}>
                    <Button
                        component="a"
                        href={queryData.site.siteMetadata.getStartedLink}
                        target="_blank"
                        variant="contained"
                        color="logo-purple"
                        fullWidth
                    >
                        شروع کنید
                    </Button>
                </Grid>
            </Grid> */}
        </BigHeaderLayout>
    );
};

ProductIndexPage.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
};

export default ProductIndexPage;
